import { HttpClient } from "@angular/common/http";
import { Injectable, LOCALE_ID, inject } from "@angular/core";
import { extractResourceInCollection } from "auth/src/lib/helpers/extractors";
import { Observable, map } from "rxjs";
import { IsoLocale, Languages } from "src/app/domain/lang";
import { PetRepository } from "src/app/domain/repositories/pet.repository";
import { environment } from "src/environments/environment";
import { Breed } from "yummypets-js-core";

export interface NotificationStats {
    pet: {
        comments: number
        follow: number
        likes: number
        members: number
        mentions: number
        messages: number
    }
    teams: number
}

@Injectable({ providedIn: 'root' })
export class PetRepositoryApi implements PetRepository {


    private path = `pets`
    readonly #http = inject(HttpClient);
    readonly locale = inject(LOCALE_ID)

    getUrl() {
        return `${environment.api}${this.path}`
    }

    fetchStatsNotifications(id: number): Observable<NotificationStats> {
        return this.#http.get<NotificationStats>(`${environment.api}${this.path}/${id}/notifications/stats`)
    }

    fetchBreeds(p = {}): Observable<Breed[]> {

        const langId = Languages.getLanguageByCode(this.locale as IsoLocale).id
        const params = Object.assign({ limit: 500, sort: 'alpha_asc', lang_id: langId}, p)
        return this.#http.get(`${environment.api}breeds`, { params }).pipe(map(extractResourceInCollection))
    }
}